import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionByDocTypeRequestModel, PermissionModel } from '../models/request/document-type-request';
import { ResultOfT } from '../models/response/result';
import { UserInfoResponseModel } from '../models/response/userInfo-response';
import { GroupResponseModel } from '../models/response/group-response';
import { AssignPermissionModel } from '../models/response/permission-response';

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends BaseService {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  GetUserWithUserPermissions(reqModel: PermissionByDocTypeRequestModel) {
    return this.post<ResultOfT<UserInfoResponseModel>>('Permission/GetUserWithUserPermissions', reqModel);
  }
  
  GetGroupWithGroupPermissions(reqModel: PermissionByDocTypeRequestModel){
    return this.post<ResultOfT<GroupResponseModel>>('Permission/GetGroupWithGroupPermissions', reqModel);
  }
  
  AddUserPermissions(reqModel: AssignPermissionModel) {
    return this.post<ResultOfT<boolean>>('Permission/AddUserPermissions', reqModel);
  }

  AddGroupPermissions(reqModel: AssignPermissionModel) {
    return this.post<ResultOfT<boolean>>('Permission/AddGroupPermissions', reqModel);
  }

  // UpdateUserPermissions(reqModel: UserInfoResponseModel) {
  UpdateUserPermissions(reqModel: AssignPermissionModel) {
    return this.post<ResultOfT<boolean>>('Permission/UpdateUserPermissions', reqModel);
  }

  // UpdateGroupPermissions(reqModel: GroupResponseModel) {
  UpdateGroupPermissions(reqModel: AssignPermissionModel) {
    return this.post<ResultOfT<boolean>>('Permission/UpdateGroupPermissions', reqModel);
  }

  DeleteUserPermissions(reqModel: PermissionByDocTypeRequestModel){
    return this.post<ResultOfT<boolean>>('Permission/DeleteUserPermissions', reqModel);
  }

  DeleteGroupPermissions(reqModel: PermissionByDocTypeRequestModel){
    return this.post<ResultOfT<boolean>>('Permission/DeleteGroupPermissions' , reqModel);
  }

  GetPermissionByUserId(userId: number , documentTypeId: number){
      return this.get<ResultOfT<PermissionModel[]>>('Permission/GetPermissionByUserId/' + userId + '/' + documentTypeId);
  }
}
